// extracted by mini-css-extract-plugin
export default {"title":"ProductSpecs_title__cNzXL","table_container":"ProductSpecs_table_container__Zszxo"};